import { createContext } from '@berlin-front/common/composables/context';
import type { Component } from 'vue';
import { UnwrapRef, reactive } from '@vue/composition-api';

export type AuthNgFailContextType = {
  useAuthNgFail: () => UnwrapRef<{
    onCancel: () => void;
    onInquiry: () => void;
    ngReasons: string[];
    detailComponent: Component | undefined;
  }>;
};

export const AuthNgFailContext = createContext<AuthNgFailContextType>({
  useAuthNgFail: () =>
    reactive({
      onCancel: () => {},
      onInquiry: () => {},
      detailComponent: undefined,
      ngReasons: [],
    }),
});
